// extracted by mini-css-extract-plugin
export default {"wrap":"acotrs_wrapP6QVY","active":"acotrs_activeSk4EQ","icon":"acotrs_iconqerK0"};